up.compiler('[data-input-icon]', (element: HTMLElement) => {
  const iconName = element.getAttribute('data-input-icon')!
  const formGroup = element.closest<HTMLElement>('.form-group')!

  formGroup.classList.add('-icon', `-${iconName}`)
})
